<template>
	<div class="wechat-success" :class="{'error': !isSuccess}">
		<h1>{{isSuccess ? '绑定成功！' : '绑定失败！'}}</h1>
		<p>{{isSuccess ? '请返回OCS+继续设置' : errmsg}}</p>
		<el-button @click.stop="handleClose" type="primary" size="mini" style="margin-top: 20px">关闭</el-button>
	</div>
</template>

<script>
	export default {
		computed:{
			isSuccess(){
			  return this.$route.query.type ? false : true
			},
			errmsg(){
				return decodeURIComponent(this.$route.query.errmsg)
				//return decodeURIComponent(escape(window.atob(this.$route.query.errmsg)))
			}
		},
		methods: {
			handleClose() {
				window.close();
			}
		},
		
	}
</script>

<style lang="scss" scoped>
	.wechat-success {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		h1 {
			font-weight: 500;
			color: #337EFF;
			line-height: 42px;
			font-size: 30px;
		}
		p {
			font-size: 18px;
			font-weight: 400;
			color: #172B4D;
			line-height: 25px;
			margin-top: 41px;
		}
		&.error {
			h1 {
				color: red;
			}
		}
		
	}
</style>
